import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './Hero.css';

const Hero = () => {
  const { scrollY } = useScroll();

  // Parallax effect: moves slower than scroll
  const y = useTransform(scrollY, [0, 500], [0, 200]);

  // Fade out effect
  const opacity = useTransform(scrollY, [0, 300], [1, 0]);

  // Scale down effect
  const scale = useTransform(scrollY, [0, 300], [1, 0.8]);

  const titleVariants = {
    hidden: { opacity: 0, y: 20, filter: 'blur(10px)' },
    visible: {
      opacity: 1,
      y: 0,
      filter: 'blur(0px)',
      transition: { duration: 1.5, ease: [0.6, 0.01, 0.05, 0.9] }
    },
  };

  const heroStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/DJphoto.png)`
  };

  return (
    <section id="hero" className="hero-section" style={heroStyle}>
      <motion.h1
        className="hero-title"
        initial="hidden"
        animate="visible"
        variants={titleVariants}
        style={{ y, opacity, scale }}
      >
        D<span className="accent-apostrophe">'</span>BUEN
      </motion.h1>
    </section>
  );
};

export default Hero;
